import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import { withTranslation } from 'react-i18next';

class ChangeStateMessageComponent extends Component {
    render() {
        return <div className="change-state-message">
            {this.icon()}
            {this.message()}
        </div>
    }

    icon() {
        if (this.props.hasChanges) {
            return <FaIcon key={"none-saved-icon"} iconName="exclamation-circle"/>
        } else {
            return <FaIcon key={"saved-icon"} iconName="check" className="saved"/>
        }
    }

    message() {
        const { t } = this.props;
        if (this.props.hasChanges) {
            return <p key={"none-saved-message"}>{t('change_state_message.unsaved_changes')}</p>
        } else {
            return <p key={"saved-message"}>{t('change_state_message.all_changes_saved')}</p>
        }
    }
}

export const ChangeStateMessage = withTranslation()(ChangeStateMessageComponent);
